import { render, staticRenderFns } from "./ReferralCodeInput.vue?vue&type=template&id=c8e8ca42&scoped=true"
import script from "./ReferralCodeInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReferralCodeInput.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReferralCodeInput.vue?vue&type=style&index=0&id=c8e8ca42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e8ca42",
  null
  
)

export default component.exports